import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, PlayCircle } from "lucide-react";
import { fetchTestimonials } from "../components/apifa";
import { SectionHeading } from "../alumni/AlumniPages";

/** Video testimonials managed in the admin (Website content > Video testimonials). */
export default function Testimonial({ limit = 3 }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    fetchTestimonials()
      .then((data) => setItems(Array.isArray(data) ? data : []))
      .catch(() => setItems([]));
  }, []);

  if (!items.length) return null;

  return (
    <section className="bg-white py-20 md:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <SectionHeading align="left" eyebrow="In their words" title="Hear from our community" />
          {items.length > limit && (
            <Link to="/testimonials" className="inline-flex items-center gap-2 font-bold text-navy-700 hover:gap-3">
              All testimonials <ArrowRight className="h-4 w-4" aria-hidden />
            </Link>
          )}
        </div>
        <div className="mt-10 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {items.slice(0, limit).map((t) => (
            <figure key={t.video_url} className="overflow-hidden rounded-3xl border border-slate-200 bg-navy-900 shadow-card">
              <video src={t.video_url} controls preload="metadata" playsInline className="aspect-video w-full bg-black object-contain" />
              <figcaption className="flex items-center gap-2 bg-white px-5 py-4 font-display font-bold text-navy-800">
                <PlayCircle className="h-5 w-5 shrink-0 text-gold-600" aria-hidden /> {t.title}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
